import { useFormikContext } from 'formik';
import styles from './KidsPriceItem.module.scss';
import { PriceFormType } from '../../../redux/types/pricesTypes';
import KidsAgesRange from '../../KidsAgesRange';
import ObjectPriceSample from '../ObjectPriceSample';
import { useEffect } from 'react';
import { clearBlockErrorsIfEmpty } from '../../../utils/clearBlockErrorsIfEmpty';

type KidsPriceItemProps = {
  index: number;
};

const KidsPriceItem = ({
  // item,
  index,
}: KidsPriceItemProps) => {
  const { setFieldValue, values, validateField, touched, errors, setErrors } =
    useFormikContext<PriceFormType>();

  useEffect(() => {
    if (index === 0) {
      values.ageKidsFree
        ? setFieldValue(`kidsPrice[0].start_age`, values.ageKidsFree)
        : setFieldValue(`kidsPrice[0].start_age`, 0);
    }
  }, [values.ageKidsFree, index]);

  useEffect(() => {
    if (index > 0 && values?.kidsPrice[index - 1]?.end_age) {
      setFieldValue(
        `kidsPrice[${index}].start_age`,
        Number(values.kidsPrice[index - 1].end_age) + 1,
      );
    }
  }, [values.kidsPrice[index - 1]]);

  useEffect(() => {
    if (values.kidsPrice[index].start_age && values.kidsPrice[index].end_age) {
      validateField(`kidsPrice[${index}].end_age`);
    }
  }, [values]);

  useEffect(() => {
    clearBlockErrorsIfEmpty(errors, setErrors, `kidsPrice[${index}].price`);
  }, [values, touched, errors]);

  return (
    <div className={styles.container}>
      <KidsAgesRange itemName={`kidsPrice[${index}]`} />
      <ObjectPriceSample itemName={`kidsPrice[${index}].price`} />
    </div>
  );
};
export default KidsPriceItem;
